import React from 'react'
import {Icon} from '@chakra-ui/react'

const UpDownIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M21.7101 15.79C21.3201 15.4 20.6901 15.4 20.3001 15.79L18.0101 18.08V4.5C18.0101 3.95 17.5601 3.5 17.0101 3.5C16.4601 3.5 16.0101 3.95 16.0101 4.5V18.09L13.7201 15.8C13.3301 15.41 12.7001 15.41 12.3101 15.8C11.9201 16.19 11.9201 16.82 12.3101 17.21L16.3101 21.21C16.4001 21.3 16.5101 21.38 16.6401 21.43C16.7601 21.48 16.8901 21.51 17.0201 21.51C17.1501 21.51 17.2801 21.48 17.4001 21.43C17.5201 21.38 17.6301 21.31 17.7301 21.21L21.7301 17.21C22.1201 16.82 22.1201 16.19 21.7301 15.8L21.7101 15.79Z"
                fill="currentColor"
            />
            <path
                d="M11.7101 7.79L7.71006 3.79C7.62006 3.7 7.51006 3.62 7.38006 3.57C7.14006 3.47 6.86006 3.47 6.62006 3.57C6.50006 3.62 6.39006 3.69 6.29006 3.79L2.29006 7.79C1.90006 8.18 1.90006 8.81 2.29006 9.2C2.68006 9.58999 3.31006 9.58999 3.70006 9.2L5.99006 6.91V20.5C5.99006 21.05 6.44006 21.5 6.99006 21.5C7.54006 21.5 7.99006 21.05 7.99006 20.5V6.91L10.2801 9.2C10.4801 9.39999 10.7301 9.49 10.9901 9.49C11.2501 9.49 11.5001 9.39 11.7001 9.2C12.0901 8.81 12.0901 8.18 11.7001 7.79H11.7101Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default UpDownIcon
